import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteUserMutation = () =>
  useTypedMutation({
    mutationFn: async (id: number) => (await ApiInstance.post(`/users/delete`, { id }, ENV.systemBaseURL)).data,
    onSuccess: id => {
      const prevUsers = typedQueryClient.getQueryData(UsersDashboardQueryKeys.users);
      if (!prevUsers) return;

      const userIdx = prevUsers.users.findIndex(user => user.id === id);
      if (userIdx === -1) return;

      typedQueryClient.setQueryData(UsersDashboardQueryKeys.users, {
        ...prevUsers,
        users: prevUsers.users.toSpliced(userIdx, 1),
        nb_items: (prevUsers.nb_items ?? 0) - 1
      });
    }
  });
